// extracted by mini-css-extract-plugin
module.exports = {"main":"content_main___hhcw"};